<footer>
    <section>
        <div class="container pt-3 pb-3">
            <div class="row">
                <div class="col-md-4 mt-3 text-center text-md-start align-content-center">
                    <img class="img-fluid" src="/assets/images/home/logo_medium.png" >
                </div>
                <div class="col-md-4 mt-3 text-center">	
                    <a class="nav-link" href="https://www.es.gov.br" >
                        <img class="img-fluid" src="/assets/images/home/Logo_SEP_Branco.png" />
                    </a>
                </div>
                <div class="col-md-4 mt-3 text-center text-md-end align-content-center">
                    <a class="btn btn-outline-light btnIcon ms-3" target="_blank" href="https://www.facebook.com/GovernoES">
                        <i class="fab fa-facebook-f"></i>
                    </a>
                    <a class="btn btn-outline-light btnIcon ms-3" target="_blank" href="https://x.com/governoes">
                        <i class="fab fa-x-twitter"></i>
                    </a>
                    <a class="btn btn-outline-light btnIcon ms-3" target="_blank" href="https://www.instagram.com/governo_Es/">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a class="btn btn-outline-light btnIcon ms-3 iconYouTube" target="_blank" href="https://www.youtube.com/governoes">
                        <i class="fab fa-youtube"></i>
                    </a>
                    <a class="btn btn-outline-light btnIcon ms-3" target="_blank" href="https://www.flickr.com/photos/governodoes/albums/">
                        <i class="fab fa-flickr"></i>
                    </a>
    
                </div>
                <div class="col-12 mt-3 text-center">
                    <i class="fa-brands fa-osi"></i> {{dateSite}}
                    <p> Secretaria de Estado de Economia e Planejamento (SEP)  </p>
                </div>
            </div>
        </div>
    </section>
</footer>